// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"147": "UnionOp","169": "Polygonizer","398": "OLparser","739": "BufferOp","846": "lineSplit",}[chunkId] || chunkId) + ".bundle.js"
}